import { render, staticRenderFns } from "./satisfactionModel.vue?vue&type=template&id=1f1445e4&scoped=true&"
import script from "./satisfactionModel.vue?vue&type=script&lang=js&"
export * from "./satisfactionModel.vue?vue&type=script&lang=js&"
import style0 from "./satisfactionModel.vue?vue&type=style&index=0&id=1f1445e4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1445e4",
  null
  
)

export default component.exports